export default __webpack_public_path__ + "static/media/enviroment.784dbf88.jpg";